/* unplugin-vue-components disabled */import { render } from "./ReleaseNote.vue?vue&type=template&id=6427b8a5&scoped=true"
import script from "./ReleaseNote.vue?vue&type=script&lang=js"
export * from "./ReleaseNote.vue?vue&type=script&lang=js"

import "./ReleaseNote.vue?vue&type=style&index=0&id=6427b8a5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6427b8a5"]])

export default __exports__